import { useTranslation } from 'react-i18next';
import { RCta } from '../RCta';
import { WCta } from '../WCta';
import { WregPhase } from '../WregPhase';
import { WREG_WORKING_MS, wregStepNumber } from '../wregSteps';
import type { WregTrackId } from '../wregScenarios';
import { SUBMIT_SWITCH_PROVIDER } from '@/consts/events';
import type { WregScreenEvent } from './wregScreenEvents';

type Props = {
  tracks: WregTrackId[];
  onSwitch: () => void;
  onDecline: () => void;
  onEvent?: WregScreenEvent;
};

const WregSwitch = ({ tracks, onSwitch, onDecline, onEvent }: Props) => {
  const { t } = useTranslation();
  const submit = (decision: 'switch' | 'decline') =>
    onEvent?.(SUBMIT_SWITCH_PROVIDER, { decision });

  return (
    <div className="rg-screen">
      <div className="rg-body">
        <div className="rg-inner">
          <div className="rg-head-block">
            <WregPhase n={wregStepNumber('switch')} />
            <h1 className="rg-h1">{t('wreg.switch.title')}</h1>
            <p className="rg-sub">{t('wreg.switch.body')}</p>
          </div>
          {tracks.length > 0 && (
            <div className="wreg-switch-tracks">
              <div className="wreg-switch-tracks-t">{t('wreg.switch.list')}</div>
              <ul className="wreg-switch-tracklist">
                {tracks.map((id) => (
                  <li key={id}>{t(`wreg.tracks.${id}.t`)}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className="rg-foot">
        <div className="rg-foot-stack c-btnset">
          <WCta
            minWorkingMs={WREG_WORKING_MS}
            onClick={() => submit('switch')}
            onDone={onSwitch}
          >
            {t('wreg.switch.cta')}
          </WCta>
          <RCta
            variant="ghost"
            onClick={() => {
              submit('decline');
              onDecline();
            }}
          >
            {t('wreg.switch.decline')}
          </RCta>
        </div>
      </div>
    </div>
  );
};

export { WregSwitch };
